// Marketplace action types
export const SET_SERVICES = "marketplace/SET_SERVICES";
export const SET_LOADING = "marketplace/SET_LOADING";
export const SET_ERROR = "marketplace/SET_ERROR";
export const SET_FILTERS = "marketplace/SET_FILTERS";
export const SET_SEARCH = "marketplace/SET_SEARCH";
export const SET_SELECTED_PLAN = "marketplace/SET_SELECTED_PLAN";

// Cart action types
export const ADD_TO_CART = "marketplace/ADD_TO_CART";
export const REMOVE_FROM_CART = "marketplace/REMOVE_FROM_CART";
export const UPDATE_CART_ITEM_QUANTITY =
  "marketplace/UPDATE_CART_ITEM_QUANTITY";
// Replaces a cart item's entire namespaced add-on selection map
// ({ [groupKey]: { [slug]: { quantity } } }). The container computes the next
// map via the selection model, so the reducer stays trivial.
export const SET_CART_ITEM_SELECTED_ADDONS =
  "marketplace/SET_CART_ITEM_SELECTED_ADDONS";
export const CLEAR_CART = "marketplace/CLEAR_CART";
export const SET_SHOW_CART = "marketplace/SET_SHOW_CART";
export const LOAD_CART_FROM_STORAGE = "marketplace/LOAD_CART_FROM_STORAGE";

// Upsell action types
export const SET_UPSELL_RECOMMENDATION =
  "marketplace/SET_UPSELL_RECOMMENDATION";
export const DISMISS_UPSELL = "marketplace/DISMISS_UPSELL";

// Coupon action types
export const APPLY_COUPON = "marketplace/APPLY_COUPON";
export const REMOVE_COUPON = "marketplace/REMOVE_COUPON";
export const SET_COUPON_LOADING = "marketplace/SET_COUPON_LOADING";
export const SET_COUPON_ERROR = "marketplace/SET_COUPON_ERROR";
export const SET_AVAILABLE_COUPONS = "marketplace/SET_AVAILABLE_COUPONS";
